module.exports = __webpack_public_path__ + "img/consumer.04421216.svg";